































import {
  computed,
  defineComponent,
  PropType,
  useContext,
} from '@nuxtjs/composition-api'
import { sendYmEvent } from './helpers'
import { YmAttrs } from '@/contracts/Ym'

export default defineComponent({
  name: 'HeaderNextButton',
  props: {
    url: { type: String, default: '' },
    label: { type: String, default: '' },
    icon: { type: String, default: '' },
    ymEvent: {
      type: Object as PropType<YmAttrs | null>,
      default: null,
    },
    accent: { type: Boolean, default: false },
    asButton: { type: Boolean, default: false },
    hideLabelBelowXxl: { type: Boolean, default: false },
    iconPosition: {
      type: String as PropType<'start' | 'end'>,
      default: 'start',
    },
  },
  setup(props) {
    const { $config } = useContext()
    const classes = computed(() => [
      'header-next-button',
      props.accent && '--accent',
      props.hideLabelBelowXxl && '--hide-label',
      `--icon-${props.iconPosition}`,
    ])

    const onMousedown = (): void => {
      sendYmEvent(props.ymEvent, $config.YM_ID)
    }

    return { classes, onMousedown }
  },
})
